<div class="display-content">
  <mat-dialog-content class="display-content">
    <h2 mat-dialog-title>{{ data.title }}</h2>
    <h5>{{ message }}</h5>
    <div *ngIf="data.response">
      <mat-list class="scrollable-list">
        <mat-list-item *ngFor="let record of data.response">
          <p class="list-item">
            {{ record.linePosition ? record.linePosition + " - " : "" }}
            {{ record.rowValues ? record.rowValues : record }}
            {{ record.errorMessage ? " - " + record.errorMessage : "" }}
          </p>
        </mat-list-item>
      </mat-list>
    </div>
  </mat-dialog-content>
  
  <mat-dialog-actions align="end">
    <button mat-button (click)="close()">
      {{ "button-close" | translate }}
    </button>
  </mat-dialog-actions>
</div>
